import { isEmailValid } from 'utils/string';
import { FormattedMessage } from 'react-intl';
import { MutationFunction } from '@apollo/client';
import { StateSetter } from 'types/utils/React';
import {AddRelationshipError, type AddRelationshipOutput} from 'graphql/relationship';
import {type ShowSnackbarFunction} from 'contexts/SnackbarContext';

const getErrorMessageId = (reason: AddRelationshipError): string => {
  if (
    [
      AddRelationshipError.ALREADY_EXISTS,
      AddRelationshipError.MAIN_USER_NOT_FOUND,
      AddRelationshipError.MINIMAL_VERSION_NOT_SATISFIED,
      AddRelationshipError.WEB_USER_ALREADY_LINKED_TO_CHANNEL,
    ].includes(reason)
  ) {
    return `relationship.error.${reason}`;
  } else {
    return 'relationship.error.internal';
  }
};

type GetHandleAssociateFunctionInputType = {
  email: string;
  addRelationshipMutation: MutationFunction;
  setHasEmailError: StateSetter<boolean>;
  setRelationshipHasBeenAdded: StateSetter<boolean>;
  errorSnackbar: ShowSnackbarFunction;
};

export const addRelationship = ({
  email,
  addRelationshipMutation,
  setHasEmailError,
  setRelationshipHasBeenAdded,
  errorSnackbar,
}: GetHandleAssociateFunctionInputType): void => {
  if (!isEmailValid(email)) {
    setHasEmailError(true);
  } else {
    addRelationshipMutation({
      variables: {
        input: {
          mainUserEmail: email,
        },
      },
    })
      .then(({ data } : { data : AddRelationshipOutput}) => {
        if (data?.addRelationship?.errorReason) {
          const errorMessageId = getErrorMessageId(
            data.addRelationship.errorReason,
          );

          errorSnackbar(<FormattedMessage id={errorMessageId} />);
        } else if (data?.addRelationship?.relationship) {
          setRelationshipHasBeenAdded(true);
        }
      })
      .catch(() =>
        errorSnackbar(<FormattedMessage id="relationship.error.internal" />),
      );
  }
};
